var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWindmill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 74,
    viewBox: "0 0 73 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.6205 2.45364L31.7103 2.60917L32.2313 32.4584L32.3868 41.3686L32.9078 71.2179L41.8181 71.0623L41.297 41.2131L41.1532 32.9711L40.6205 2.45364Z",
    fill: "white",
    fillOpacity: 0.08
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1532 32.9711L70.9985 32.2274L71.1463 40.6921L41.297 41.2131L41.1532 32.9711Z",
    fill: "white",
    fillOpacity: 0.08
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3868 41.3686L2.53758 41.8896L2.38205 32.9794L32.2313 32.4584L32.3868 41.3686Z",
    fill: "white",
    fillOpacity: 0.08
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.3705 0.640161L29.8962 0.857901L31.156 73.0307L43.6303 72.8129L42.3705 0.640161ZM41.495 1.54674L30.8028 1.73337L30.9116 7.97052L41.6039 7.78389L41.495 1.54674ZM30.9272 8.86155L41.6194 8.67491L41.7283 14.9121L31.036 15.0987L30.9272 8.86155ZM41.7439 15.8031L31.0516 15.9897L31.1605 22.2269L41.8527 22.0402L41.7439 15.8031ZM31.176 23.1179L41.8683 22.9313L41.9772 29.1684L31.2849 29.3551L31.176 23.1179ZM41.9927 30.0594L31.3004 30.2461L31.4093 36.4832L42.1016 36.2966L41.9927 30.0594ZM31.4249 37.3743L42.1171 37.1876L42.226 43.4248L31.5337 43.6114L31.4249 37.3743ZM42.2416 44.3158L31.5493 44.5024L31.6582 50.7396L42.3504 50.5529L42.2416 44.3158ZM31.6737 51.6306L42.366 51.444L42.4748 57.6811L31.7826 57.8678L31.6737 51.6306ZM42.4904 58.5721L31.7981 58.7588L31.907 64.9959L42.5993 64.8093L42.4904 58.5721ZM31.9226 65.887L42.6148 65.7003L42.7237 71.9375L32.0314 72.1241L31.9226 65.887Z",
    fill: "white",
    fillOpacity: 0.08
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.567963 31.2282L0.785703 43.7025L72.9585 42.4427L72.7407 29.9684L0.567963 31.2282ZM1.47454 32.1036L1.66117 42.7959L7.89833 42.687L7.71169 31.9948L1.47454 32.1036ZM8.78934 42.6715L8.60271 31.9792L14.8399 31.8703L15.0265 42.5626L8.78934 42.6715ZM15.7309 31.8548L15.9175 42.547L22.1547 42.4382L21.968 31.7459L15.7309 31.8548ZM23.0457 42.4226L22.8591 31.7304L29.0962 31.6215L29.2829 42.3138L23.0457 42.4226ZM29.9872 31.6059L30.1739 42.2982L36.411 42.1893L36.2244 31.4971L29.9872 31.6059ZM37.3021 42.1738L37.1154 31.4815L43.3526 31.3726L43.5392 42.0649L37.3021 42.1738ZM44.2436 31.3571L44.4302 42.0494L50.6674 41.9405L50.4807 31.2482L44.2436 31.3571ZM51.5584 41.9249L51.3718 31.2327L57.6089 31.1238L57.7956 41.8161L51.5584 41.9249ZM58.4999 31.1082L58.6866 41.8005L64.9237 41.6916L64.7371 30.9994L58.4999 31.1082ZM65.8148 41.6761L65.6281 30.9838L71.8653 30.8749L72.0519 41.5672L65.8148 41.6761Z",
    fill: "white",
    fillOpacity: 0.08
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindmill);
export default __webpack_public_path__ + "static/media/windmill.9bbcef82d39096ce58e91c097a2b812a.svg";
export { ForwardRef as ReactComponent };